<template>
    <div class="content" :style="{'height':winHeight +'px'}">

        <div class="body">
            <div class="body_title"  >
                <div class="body_title_icon"></div>
                <div>
                    <span>用户信息</span>
                    <el-icon size="30" color="#333333" style="top: 5px;left: 8px;" @Click="btnClick" ><EditPen /></el-icon>
                </div>
            </div>
            <div class="body_content">
                <div class="body_content_row">
                    <div class="body_content_row_title">昵称: </div>
                    <div class="body_content_row_content">{{userInfo.nickName}}</div>
                </div>
                <div class="body_content_row">
                    <div class="body_content_row_title">头像: </div>
                    <div class="body_content_row_content">{{userInfo.companySimpleName}}</div>
                    <img style="height:50px;width:50px;border: 2px solid #f2f2f2;border-radius: 50%;" :src="userInfo.headerUrl">
                </div>
                <div class="body_content_row">
                    <div class="body_content_row_title">年龄: </div>
                    <div class="body_content_row_content">{{userInfo.age}}</div>
                </div>
                <div class="body_content_row">
                    <div class="body_content_row_title">性别: </div>
                    <div class="body_content_row_content">{{userInfo.gender==0?'男':'女'}}</div>
                </div>
                <div class="body_content_row">
                    <div class="body_content_row_title">手机号: </div>
                    <div class="body_content_row_content">{{userInfo.phone}}</div>
                </div>
            </div>
        </div>

        <!-- 新建编辑 -->
        <dialogForm ref="dialogForm" :center="true"></dialogForm>
    </div>
</template>

<script>
    import dialogForm from '@/components/dialogForm.vue'

    export default {
        name: "userInfo",
        components:{
            dialogForm,
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo
            },
        },
        data() {
            return {
                winHeight: `${document.documentElement.clientHeight}` - 122,
                detail: {},
                //region 新建编辑数据
                dialogFormData: {
                    state: true,
                    title: '',
                    form: [
                        {label: "昵称", prop: 'nickName', type: 'text', width:500 },
                        {label: "年龄", prop: 'age', type: 'text', width:500 },
                        {label: "性别", prop: 'gender', type: 'radio', width:500,
                            sourceList:[{value:'0', text:'男'},{value:'1', text:'女'}]},
                    ],
                    data:{},
                    rules: {
                        nickName: [
                            {required: true, message: '请输入昵称', trigger: 'blur'},
                            {min: 0, max: 20, message: '超出最大长度10', trigger: 'blur' },
                        ],
                        age: [
                            {required: true, message: '请输入年龄', trigger: 'blur'},
                            {min: 0, max: 10, message: '超出最大长度10', trigger: 'blur' },
                        ],
                    },
                    onSubmit: res => {
                        this.$POST("/author/EomsUser/updateEomsUser", this.$tools.getObjData(res.data)).then(e => {
                            this.$message.success("保存成功,请重新登录!");
                            this.dialogFormData.state = false;
                            this.$router.push({ name:'login'});
                        })
                    }
                },
                //endregion
            }
        },
        methods: {

            /**
             * 按钮点击
             */
            btnClick(e){
                this.dialogFormData.state = true;
                this.dialogFormData.title = '编辑用户信息';
                this.dialogFormData.data = JSON.parse(JSON.stringify(this.userInfo));
                this.dialogFormData.data.age = this.dialogFormData.data.age+"";
                this.dialogFormData.data.gender = this.dialogFormData.data.gender+"";
                this.$refs.dialogForm.initData(this.dialogFormData);
            },
        },

        mounted() {

        }
    }
</script>

<style scoped>
    .content{
        position: relative;
        height: 100%;
        width: 100%;
        background: #ffffff;
    }

    .body{
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        background: #ffffff;
        border-radius: 8px;
        z-index: 9;
    }
    .body_title{
        position: relative;
        height: 80px;
        display: flex;
        justify-content: start;
        align-items: center;
        font-size: 28px;
        font-weight: 800;
        cursor: pointer;
    }
    .body_title_icon{
        position: relative;
        bottom: 0;
        height: 28px;
        width: 10px;
        background: linear-gradient(to bottom, #ff6633, #ff6633);
        border-radius: 4px;
        margin-top: 2px;
        margin-left: 20px;
        margin-right: 10px;
    }
    .body_content{
        position: relative;
        width: 100%;
        overflow: hidden;
        padding-bottom: 30px;
    }
    .body_content_row{
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        width: 97%;
        height: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size:24px;
        margin-top: 10px;
    }
    .body_content_row_content{
        margin-left: 10px;
    }
</style>
